import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../config/api";

export const fetchCards = createAsyncThunk(
    'payment/fetchAllCards',
    async (_, { rejectWithValue }) => {
        try {
            let res = await axiosInstance.get('/stripe/list-card');
            if (res?.status == 200 || res?.data?.status == 200) {
                return res?.data?.data?.cards
            } else {
                return rejectWithValue('Failed to fetch cards');
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error?.response?.data?.error?.message);
        }
    }
)

const initialState = {
    loading: false,
    cards: [],
    error: null
}

export const paymentSlice = createSlice({
    name: "payment",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCards.pending, (state) => {
            state.loading = true;
            state.cards = [];
            state.error = null
        });
        builder.addCase(fetchCards.fulfilled, (state, action) => {
            state.loading = false;
            state.cards = action.payload;
            state.error = null
        });
        builder.addCase(fetchCards.rejected, (state, action) => {
            state.loading = false;
            state.cards = [];
            state.error = action.payload || 'Failed to fetch service providers'
        })
    }
})

export default paymentSlice.reducer